import ylorrddata from "./raw/ylorrd.json";

export const YlOrRdColorMap = (type) => {
  if (type === "range") {
    return ylorrddata;
  }
};
